<template>

    <div>

        <v-google-one-tap />

        <v-hero />

        <v-section-clients />

        <v-section-feature
            image-side="r"
            icon="fas fa-paper-plane"
            image="/img/home-bullet1.png"
            subtitle="Automate"
            title="Onboard customers with automations"
            :headline="this.$t('feature.engagement.headline')"
            slug="feature-engagement"
            :testimonial="this.$t('testimonial.partnered')">
        </v-section-feature>

        <v-section-feature
            image-side="l"
            icon="fas fa-id-card"
            image="/img/home-bullet2.png"
            subtitle="Analyze"
            title="See real-time customer activity"
            :headline="this.$t('feature.management.headline')"
            slug="feature-management"
            :testimonial="this.$t('testimonial.helplk')">
        </v-section-feature>

        <v-section-feature
            image-side="r"
            icon="fas fa-chart-pie"
            image="/img/home-bullet3.png"
            subtitle="Organize"
            title="Build customer lists for email campaigns"
            :headline="this.$t('feature.segmenting.headline')"
            slug="feature-segmenting"
            :testimonial="this.$t('testimonial.pr24')">
        </v-section-feature>

        <v-section-feature
            image-side="l"
            icon="fas fa-envelope-open-text"
            image="/img/home-bullet4.png"
            subtitle="Engage"
            title="Send personalized emails that deliver"
            :headline="this.$t('feature.email.headline')"
            slug="feature-email"
            :testimonial="this.$t('testimonial.peterteszary')">
        </v-section-feature>

        <v-section-campaigns />
        <v-section-integrations />
        <v-section-install />
        <v-section-testimonials />
        <v-section-reviews />
        <v-section-signoff />

    </div>

</template>

<script>

import Hero from './components/Hero';
import SectionFeature from './components/SectionFeature';

export default {

    components: {
        'v-hero': Hero,
        'v-section-feature': SectionFeature,
    },

    computed: {

        ref() {
            let ref = this.$route.query.ref;
            return ref ? ref.toLowerCase() : '';
        },

    },

    methods: {

        signup() {
            window.location.href = process.env.VUE_APP_APP_URL + '/signup';
        },

    },

}

</script>
